import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

//Label Link
// Example:
{/* 
<LinkLabel for={rowInfo.original.variantName}
           path={'/variantdashboard/' + rowInfo.original.variantName}
           text={rowInfo.original.variantName}
           state={{variantId: rowInfo.original.variantId,
                   variantName: rowInfo.original.variantName,
                   breadCrumbs: this.props.breadCrumbs}}
            />
*/}

const LinkLabel = (props) => {  
    return(
      <RouterLink
        to={props.path}
        state={props.state}
      >
        {props.text}
      </RouterLink>
    )
            }

export default LinkLabel